import { render, staticRenderFns } from "./trade-agreement.vue?vue&type=template&id=28024806&"
import script from "./trade-agreement.vue?vue&type=script&lang=js&"
export * from "./trade-agreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports